import '../../vendor/rellax.min.js';




const parallax = (settings = {}) => {
    const { rellaxClass, rellaxSettings, target, attr} = settings;
    const relSets =  rellaxSettings ? rellaxSettings : {};

    const findTarget = setInterval(() => {
        if($(target).length > 0){
            clearInterval(findTarget);
            $(target)
            .addClass(rellaxClass)
            .attr(attr)
            .closest('.image__wrapper')
            .css('overflow', 'hidden')
        }
    },200);

    const findRellax = setInterval(() => {
        if($(`.${rellaxClass}`).length > 0 ){
            clearInterval(findRellax);
            const rellax = new Rellax(`.${rellaxClass}`, relSets)
        }
    },200);
}

export default parallax;


